<template>
	<div id="detail">
		<div class="container">
			<!-- 面包宵 搜索-->
			<div class="column-search">
				<!-- 面包屑导航-->
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>

					<el-breadcrumb-item>技术详情</el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<!-- 详情图片，详情属性-->
			<div class="detail-info">
				<div class="detail-slide">
					<div class="slide-warper">
						<el-image v-if="data.img" style="width: 360px; height: 240px" :src="data.img[index]"
							fit="cover"></el-image>
					</div>
					<div class="thumb-warper">

						<div class="little_img">
							<ul ref="imgList">
								<li :class="index == i ? 'on' :''" v-for="(item,i) in data.img" :key="i"
									@click='getIndex(i)'>
									<el-image style="width: 74px; height: 54px" :src="item" fit="cover"></el-image>
								</li>
							</ul>
						</div>
					</div>

				</div>
				<div class="detail-prop">
					<h2 class="artname">{{data.title}}</h2>
					<!-- <p> <span class="text-brown">专利(申请号)：</span></p> -->
					<p class="fl width-50"><span class="text-brown">专利状态：</span>有</p>
					<p class="fl width-50">
						<span class="text-brown">标签：</span>
						<span style="margin-right: 10px;" v-for="(item,i) in data.tag" :key="i">{{item}}</span>
					</p>
					<p class="fl width-50" v-if="data.finish"><span
							class="text-brown">第一完成单位：</span>{{data.finish.unit}}</p>
					<!-- <p class="fl width-50"><span class="text-brown">所在地：</span>内蒙古-鄂尔多斯 </p> -->
					<p class="fl width-50"><span class="text-brown">最近更新：</span>{{data.updated_at}}</p>
					<p class="fl width-50" v-if="data.finish"> <span
							class="text-brown">成果完成人：</span>{{data.finish.people}}</p>
					<!-- <p class="fl width-50"> <span class="text-brown">交易方式：</span>面议</p> -->
					<p> <span class="text-brown">价格：{{data.reference_price}}</span></p>
					<el-row>
						<el-col :span="12">合作方式：
							<span v-for="(v,k) in data.cooperation_type" :key="k">{{v}} </span>
						</el-col>
						<el-col :span="12">技术成熟度：{{data.maturity}}</el-col>
					</el-row>
					<el-row class="">
						<el-col :span="12">国家：{{data.country}}</el-col>
						<el-col :span="12">项目编号：{{data.number}}</el-col>
					</el-row>
					<div class="detail-btn" @click="centerDialogVisible = true">
						<div class="btn">我要咨询</div>

					</div>
					<el-dialog class="dialog1" title="立即咨询" :visible.sync="centerDialogVisible" width="20%" center>
						<el-form :model="form">
							<el-form-item>
								<el-input v-model="form.name" autocomplete="off" placeholder="我们该如何称呼您"></el-input>
							</el-form-item>
							<el-form-item>
								<el-input v-model="form.tel" autocomplete="off" placeholder="请输入您的手机号"></el-input>
							</el-form-item>
							<el-form-item>
								<el-input v-model="form.content" autocomplete="off" placeholder="请输入您要咨询的内容">
								</el-input>
							</el-form-item>
						</el-form>
						<span slot="footer" class="dialog-footer">
							<div class="btn" @click="onSubmit">提交</div>
						</span>
					</el-dialog>
				</div>
			</div>
			<!-- 免责声明-->
			<div class="clearfix">
				<div class="main">
					<div class="tabs-container">
						<el-tabs type="border-card" @tab-click="move(1)">
							<el-tab-pane label="技术详情">
								<div class="tab-content">
									<div class="tab-pane-detail">
										<!-- 项目简介-->
										<div class="detail-item" id="item1">
											<h4 class="detail-title"> <span>项目简介</span></h4>
											<div class="detail-content" v-html="data.xmhjsqk">
											</div>
										</div>
										<div class="detail-item" id="item1">
											<h4 class="detail-title"> <span>应用领域</span></h4>
											<div class="detail-content" v-html="data.yyly">
											</div>
										</div>


									</div>
								</div>
							</el-tab-pane>

						</el-tabs>
					</div>
					<!-- 猜您感兴趣的-->
					<div class="panel">
						<div class="panel-head">
							<h4 class="text-brown font-18">猜您感兴趣的</h4>
						</div>
						<div class="panel-body">
							<ul class="interest-list clearfix likes">
								<li v-for="(v,k) in achievemnet" @click="click_achi(v.id)" :key="k">
									<div class="a">
										<div class="img-box">
											<el-image style="width: 207px; height: 138px" :src="v.img[0]" fit="cover">
											</el-image>
										</div>
										<span>{{v.title}}</span>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
				<div class="sidebar">
					<div class="advertisement">
						<div class="user">
							<img src="https://kejiniu.oss-cn-zhangjiakou.aliyuncs.com/app/logo_60x60.png" alt="">
							<div class="name">科技牛</div>
							<div class="post">资深顾问专家</div>
						</div>
						<div class="form">
							<el-input v-model="form.name" placeholder="请输入您的姓名"></el-input>
							<el-input v-model="form.tel" placeholder="请输入您的联系方式"></el-input>
							<el-input type="textarea" :maxlength="200" :rows="7" placeholder="简单描述一下您的需求"
								v-model="form.content">
							</el-input>
							<button @click="onSubmit">提交</button>
						</div>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	export default {
		name:'AchievementDetail',
		metaInfo: {
			title: '科技牛—为企业精准匹配科研专家以及提供技术解决方案的服务平台',
			meta: [{
					name: 'keywords',
					content: '技术对接,技术交易,技术对接平台,技术创新服务,技术转移,成果转化,技术推广,解决方案'
				},
				{
					name: 'description',
					content: '科技牛是一家专业为企业提供四技服务:技术开发、技术转让、技术咨询、技术服务，精准匹配科研专家及技术解决方案平台公司'
				}
			]
		},
		components: {

		},
		data() {
			return {
				index: 0,
				collect: false,
				centerDialogVisible: false,
				form: {
					name: '',
					content: '',
					tel: '',
					id: '',
				},
				data: {},
				id: '',
				achievemnet_post: {
					limit: 4,
					page: 1,
				},
				achievemnet: []
			}
		},
		computed: {

		},
		watch: {
			$route(to) {
				if (to.path == '/achivement/detail') {
					this.id = to.query.id;
					this.get_detail();
					this.$nextTick(function() {
						document.querySelector('#app').scrollIntoView({
							behavior: "auto"
						});
					})

				}
			},
		},
		mounted() {
			this.id = this.$route.query.id;
			this.get_detail();

		},
		methods: {
			zixun() {
				this.centerDialogVisible = false
				this.onSubmit();
			},
			onSubmit() {

				if (this.form.name == '') {
					this.$message.error('请输入您的姓名')
					return false;
				}
				if (this.form.tel == '') {
					this.$message.error('请输入您的手机号')
					return false;
				}
				if (this.form.content == '') {
					this.$message.error('请输入您咨询的内容')
					return false;
				}
				this.form.id = this.id,
					this.$http_qm.post('form/add', {
						info: this.form,
						type: 10,
					}).then(res => {
						this.$message.info(res.msg)
						if (res.code == 200) {
							this.form.content = '';
							this.form.tel = '';
							this.form.name = '';
							this.centerDialogVisible = false
						}
					}).catch(err => {
						console.log(err)
					})
			},

			click_achi(id) {
				this.$router.push({
					path: '/achivement/detail',
					query: {
						id: id
					}
				})
				// this.id = id;
				/* this.get_detail();
				 */
			},
			async List() {
				await this.$http_qm.post('achievement2/list', this.achievemnet_post).then(res => {
					if (res.code == 200) {
						this.achievemnet = res.data;
					}
				}).catch(err => {
					console.log(err);
				})
			},
			get_detail() {
				this.$http_qm.post('achievement2/detail', {
					id: this.id
				}).then(res => {
					if (res.code == 200) {
						this.data = res.data;
						this.achievemnet_post.tag = this.data.tag;
						this.achievemnet_post.not_id = this.data.id;
						this.List();
					}
				}).catch(err => {
					console.log(err);
				})
			},
			getIndex(i) {
				this.index = i;
			},
			move(key) {
				// 获取点击的按钮对应页面的id
				var PageId = document.querySelector('#item' + key)
				// 打印出对应页面与窗口的距离
				console.log(PageId.offsetTop)
				// 使用平滑属性，滑动到上方获取的距离
				// 下方我只设置了top，当然 你也可以加上 left 让他横向滑动
				// widow 根据浏览器滚动条，如果你是要在某个盒子里面产生滑动，记得修改
				window.scrollTo({
					'top': PageId.offsetTop,
					'behavior': 'smooth'
				})
			},
			prev() {
				if (this.index <= 0) {
					this.index = this.imgUrl.length - 1;
				} else {
					this.index--
				}
			},
			next() {
				if (this.index >= this.data.img.length - 1) {
					this.index = 0;
				} else {
					this.index++
				}
				if (this.index > 3) {
					this.$refs.imgList.style.right = 80 + 'px';
				}
			},
			do_Collect() {

				this.$http.post('collect/add', {
					type: 2,
					collect_id: this.id,
					is_collect: this.data.is_collect
				}).then(res => {
					if (res.code == 200) {
						this.data.is_collect = res.data.is_collect;
					} else if (res.code == 401) {
						this.$router.push({
							path: '/loagin'
						})
					} else {
						this.$message.info(res.msg)
					}
				}).catch(err => {
					console.log(err)
				})
			}
		}
	}
</script>

<style lang="less" src="../../assets/css/achievement.less">
